var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-settings" },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.dialogTitle,
            placement: "top-end",
            arrow: false
          }
        },
        [
          _c("CompassIconButton", {
            staticClass: "listing-settings__button",
            attrs: { icon: "settings-fill" },
            on: { click: _vm.openDialog }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            primaryAction: _vm.primaryAction,
            secondaryActions: _vm.secondaryActions,
            visible: _vm.displaySettingsDialog,
            size: "small"
          },
          on: { "update:visible": _vm.closeDialog }
        },
        [
          _vm.displayTabsSettings
            ? _c(
                "CompassTabs",
                {
                  model: {
                    value: _vm.selectedTab,
                    callback: function($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab"
                  }
                },
                [
                  _vm.enableColumnsSettings
                    ? _c(
                        "CompassTabPane",
                        {
                          staticClass:
                            "listing-settings__tab-content listing-settings__tab-columns",
                          attrs: {
                            label: _vm.$t.__(
                              "listing.settings.ListingSettings.tabs.columns.title"
                            ),
                            name: "columns"
                          }
                        },
                        [
                          _c("ListingSettingsTabsColumn", {
                            ref: "listingSettingsTabsColumn",
                            attrs: {
                              columns: _vm.newSettings.columns,
                              searchable: _vm.searchableColumns
                            },
                            on: {
                              updateColumns: function(columns) {
                                _vm.newSettings.columns = columns
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enablePaginationSettings
                    ? _c(
                        "CompassTabPane",
                        {
                          staticClass: "listing-settings__tab-content",
                          attrs: {
                            label: _vm.$t.__(
                              "listing.settings.ListingSettings.tabs.rows.title"
                            ),
                            name: "rows"
                          }
                        },
                        [
                          _c("ListingSettingsTabsPagination", {
                            attrs: { limit: _vm.newSettings.limit },
                            on: {
                              updateLimit: function(limit) {
                                _vm.newSettings.limit = limit
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm.enableColumnsSettings
            ? _c("ListingSettingsTabsColumn", {
                ref: "listingSettingsTabsColumn",
                attrs: {
                  columns: _vm.newSettings.columns,
                  searchable: _vm.searchableColumns
                },
                on: {
                  updateColumns: function(columns) {
                    _vm.newSettings.columns = columns
                  }
                }
              })
            : _c("ListingSettingsTabsPagination", {
                attrs: { limit: _vm.newSettings.limit },
                on: {
                  updateLimit: function(limit) {
                    _vm.newSettings.limit = limit
                  }
                }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }